import React from "react";
import PropTypes from "prop-types";
import withStyles from "@mui/styles/withStyles";
import Loading from "../components/animation/loading/Loading";
const LoadingScreen = ({
  classes
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.loadingScreenContainer
  }, /*#__PURE__*/React.createElement(Loading, {
    label: "Loading content ....stay with us"
  }));
};
const styles = {
  loadingScreenContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fafafa"
  }
};
export default withStyles(styles)(LoadingScreen);
LoadingScreen.propTypes = {
  classes: PropTypes.object.isRequired
};